export default __webpack_public_path__ + "static/media/tvg.03621947.png";